module.exports = __webpack_public_path__ + "24e004ab/img/send-icon.3cfb6275.svg";